import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "../../global/global";
import { ImageUrls } from "src/app/services/s3buket";
import { LastStepperService } from "src/app/services/last-stepper/last-stepper.service";
import { HttpParams } from "@angular/common/http";

@Component({
  selector: "app-common-seeall",
  templateUrl: "./common-seeall.component.html",
  styleUrls: ["./common-seeall.component.css"]
})
export class CommonSeeallComponent implements OnInit {

  jobsData: any = {};
  jobTitle:any;
  recruiterImagePath = ImageUrls.BaseUrl + ImageUrls.directories.recruiter;
  isPreferencesCompleted:any;
	modalScrollDistance = 2;
	modalScrollThrottle = 50;
	limit = 5;
	skip = 1;
	totalCount: any;
	jobID: any;
	noData: any = false;
  extraParams: any;
  constructor(public route: ActivatedRoute, private router: Router, private api: AdminService,
    private lastStepperService: LastStepperService) {
    this.lastStepperService.lastStepperObserver.subscribe(stepper => {
      if (stepper) {
        this.isPreferencesCompleted =stepper.isPreferences;
      }
    });
     
    
  }

  ngOnInit(): void {
    this.jobID = this.route.snapshot.paramMap.get("id")
    this.route.queryParams
      .subscribe(params => { 
       this.jobTitle=params.type.toString();
       if(this.jobTitle == "indus"){
        this.extraParams = params.extras
        this.getAllIndustry()
       } else if(this.jobTitle == "latest"){
        this.extraParams = params.extras
        this.getAllJobs();
       } else if(this.jobTitle == "roles"){
        this.extraParams = params.extras
        this.getJobs(this.extraParams);
       }
      }
    );
   }
 

  getAllJobs() {
    this.api.getData(this.isPreferencesCompleted == 1 ? apiUrl._recommendedJob : apiUrl.latestJob, {})
      .subscribe((res) => this.jobsData = res.data, (err) => { console.log(err.error.message, "error"); });
  }
  
  getAllIndustry() {
    this.api.getData(this.isPreferencesCompleted == 1 ? apiUrl._dashboardForActiveUser : apiUrl._dashboardForGuestUser, {})
      .subscribe((res) => this.jobsData = res.data, (err) => { console.log(err.error.message, "error"); });
  }
  getJobs(categoryId) {
    const data = {
      "skip": this.skip.toString(),
      "limit": this.limit.toString(),
      "categoryId": [categoryId]
    }
    this.api.postData(apiUrl._industryJobs, data).subscribe((res) => {
      this.jobsData = res.data.listing;
      this.totalCount = res.data.count;
      this.noData = true;
    })
  }
  onJobSaved(job: any) {
    job.saveStatus = job.saveStatus == 1 ? 0 : 1;
  }
  /** Infinite Scroll */
	onScrollDown() {
		
	}
	onModalScrollDown() {
		this.limit = this.totalCount;
    this.getAllJobs();
	}
}
